import React from 'react';

interface NpsScoreBadgeProps {
  score: number;
  size?: 'sm' | 'md' | 'lg';
}

const NpsScoreBadge: React.FC<NpsScoreBadgeProps> = ({ score, size = 'md' }) => {
  const rounded = Math.round(score);

  const colorClass =
    rounded >= 9
      ? 'bg-emerald-100 text-emerald-700 border-emerald-200'
      : rounded >= 7
        ? 'bg-yellow-100 text-yellow-700 border-yellow-200'
        : 'bg-red-100 text-red-700 border-red-200';

  const sizeClass =
    size === 'lg'
      ? 'w-14 h-14 text-xl font-bold'
      : size === 'sm'
        ? 'w-8 h-8 text-sm font-semibold'
        : 'w-10 h-10 text-base font-bold';

  return (
    <div
      className={`flex items-center justify-center rounded-full border ${colorClass} ${sizeClass} flex-shrink-0`}
    >
      {score % 1 === 0 ? rounded : score.toFixed(1)}
    </div>
  );
};

export default NpsScoreBadge;
